import { Injectable } from "@angular/core";
import { SituacaoDocumento } from "@tivic-team/manager-ts/dist/ptc/entities/situacao-documento.entity";
import { SituacaoDocumentoController } from "app/controllers/ptc/situacao-documento.controller";
import { CartaoDocumentoDTO } from "app/model/dtos/mob/cartao-documento.dto";
import { LoaderService } from "../loader.service";
import { SituacaoDocumentoSearch } from "./situacao-documento.search";


@Injectable()
export class SituacaoDocumentoServices{
    constructor(
        private _situacaoDocumentoController: SituacaoDocumentoController,
        private _loaderService: LoaderService
    ){}

    async find(situacaoDocumentoSearch?: SituacaoDocumentoSearch): Promise<SituacaoDocumento[]>{
        try{
            return await this._situacaoDocumentoController.find(situacaoDocumentoSearch && situacaoDocumentoSearch.getFilters() || null);
        } catch(error){
            return [];
        }
    }
    
    async findSolicitacao(situacaoDocumentoSearch?: SituacaoDocumentoSearch): Promise<Array<CartaoDocumentoDTO>> {
        this._loaderService.show()
            return this._situacaoDocumentoController.findSolicitacao(situacaoDocumentoSearch && situacaoDocumentoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
    }

    async findSituacao(situacaoDocumentoSearch?: SituacaoDocumentoSearch): Promise<Array<SituacaoDocumento>> {
        this._loaderService.show()
        try {
            return await this._situacaoDocumentoController.findSituacao(situacaoDocumentoSearch && situacaoDocumentoSearch.getFilters() || null).finally( () => this._loaderService.hide()); 
        }
        catch (error) { 
            this._loaderService.hide()
            return null; 
        }
    }
    async relatorioSituacaoDocumento(situacaoDocumentoSearch?: SituacaoDocumentoSearch): Promise<Blob>{
        this._loaderService.show();
        return this._situacaoDocumentoController.relatorioSituacaoDocumento((situacaoDocumentoSearch && situacaoDocumentoSearch.getFilters()) || null).finally(() => this._loaderService.hide());
    }
}
